<div class="sites-nav__mode">
  <nb-select [selected]="showArchived" size="tiny" (selectedChange)="archiveChange.emit($event)">
    <nb-option [value]="true">Archived</nb-option>
    <nb-option [value]="false">Active</nb-option>
  </nb-select>
</div>
